<script type="application/ld+json">
	{     
		"@context": "http://schema.org",
		"@type": "BreadcrumbList",
		"itemListElement": [
		{
		  "@type": "ListItem",
		  "position": 1,
		  "item": {
		    "@id": "https://www.protectt.ai/",
		    "name": "Home"
		  }
		},{
		  "@type": "ListItem",
		  "position": 2,
		  "item": {
		    "@id": "https://www.protectt.ai/mprotectt-biz-plus",
		    "name": "MProtectt Biz+"
		  }
		}		]
	}
	</script>
<!-- Breadcrumbs -->
<div class="breadcrumbs">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ul class="breadcrumbsul">
          <li><a href="#">Home</a></li>
          <li>></li>
          <li>MProtectt Biz+</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
          <h2 id="bnr-subheading">{{subheading}} </h2>
          <a class="btn-rectangle btn-transparent btn" data-toggle="modal" data-target="#modalContactForm">Request A
            Demo</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Banner For Mobile -->

<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <div class="mt-50">
          <!-- header background -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none subbanner" (window:resize)="onResize($event)">
  <div class="row">
    <div class="col-12">
      <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
        <h1 id="bnr-heading">{{heading}}</h1>
        <h4 id="bnr-subheading">{{subheading}}</h4>
        <a class="btn-rectangle btn-transparent btn" data-toggle="modal" data-target="#modalContactForm">Request A
          Demo</a>
        <a class="btn-rectangle btn-transparent btn ml-2" href="tel:8850106650">
          <!-- <i class="fa fa-phone" aria-hidden="true"></i>  -->
          <img src="assets/images/app-protectt/phone_icon.png" alt="Phone">
          +91-8850106650
        </a>
      </div>
    </div>
  </div>
</div>
<!-- End Introduction -->

<!-- Start Agency Benefits Area -->
<div class="section-agency-benefit bg-gray">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <div class="agency-thumb">
          <div class="thumb">
            <img src="assets/images/mobile-protectt/mobile-protectt1.webp" class="og_image_url" alt="Safeguard Confidential information of your Business">
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="agency-benefits">
          <div class="content">
            <div>
              <h2>Mobile devices in organizations are creating a security Gap</h2>
            </div>
            <p>We trust our mobile devices and carry everywhere with us. Employee always carry a mobile with him and
              access confidential information of your business easily and in less amount of time through emails etc.</p>
            <p>The problem is security on mobile devices is often overlooked and thus, leaks to data leakage in
              irresponsible hands. </p>
            <p>MProtectt™ helps you secure your employees mobile device and at the same time safeguard your data
              integrity.</p>
            <p>MProtectt™ provides your business and employees the flexibility to operate anywhere and access
              email without containerization.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Agency Benefits Area -->

<!-- Start Products Style-->
<div class="section-service section-pt">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 ">
        <div class="section-title text-center">
          <span style="color: #da2b27;">Complete Mobile Device Security</span>
          <h2>Protect your Mobile Devices</h2>
        </div>
      </div>
    </div>
    <div class="row ">
      <div class="agency-thumb">
        <div class="thumb">
          <img src="assets/images/mobile-protectt/services1.webp" alt="Features of the Mobile Security App">
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Products Style-->

<!-- Start MDM vs App Protectt -->
<div class="section-agency-benefit section-pt bg-gray section-pb-60">
  <div class="container">
    <!-- <div class="row align-items-center"> -->
    <div class="row">
      <div class="col-1 d-none d-lg-block"></div>
      <div class="col-md-12 col-lg-10 text-center">
        <img src="../../../assets/images/mprotectt_biz_plus.webp" alt="table" class="img-fluid">
      </div>
    </div>
  </div>
</div>

<!-- End MDM vs App Protectt -->

<div class="modal fade" id="modalContactForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div style="background: #163e6f" class="p-2">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onReset()" #closebutton>
          <span style="color: #fff" aria-hidden="true">&times;</span>
        </button>
        <h4 style="color: #fff" class="modal-title w-100 font-weight-bold">
          Contact Us
        </h4>
        <h6 style="color: #fff">Discuss your cyber security needs</h6>
      </div>
      <div style="display: block" class="modal-header text-center">
        <p class="formparagraph1">Protectt.ai cherish your excellent decision Talk to Protectt.ai
          to
          learn more about how we can secure your mobile app and its data, by filling out the form below.
          For
          product support, please visit our contact sales page.
        </p>
      </div>
      <div class="modal-body mx-3">
        <form [formGroup]="demoForm" class="contactusform">
          <div class="row">

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Name*</label>
              <input type="text" placeholder="Enter Your Name" id="form34" class="form-control validate input"
                formControlName="name" name="name"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.name.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.name.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.name.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.name.errors.pattern">* Please enter valid name</div>
                <div *ngIf="getDemoForm.name.errors.maxlength">* Please enter valid name</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Email*</label>
              <input type="email" placeholder="Enter Your Email " formControlName="email" class="form-control input"
                id="email" name="email" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.email.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.email.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.email.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.email.errors.pattern">* Email must be valid</div>
                <div *ngIf="getDemoForm.email.errors.isValidEmail">* Plaese enter business email</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-4">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Phone
                Number*</label>
              <input type="text" placeholder="Enter Your Phone Number" id="form34" class="form-control validate input"
                formControlName="contactnumber" name="contactnumber"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.contactnumber.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.contactnumber.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.contactnumber.errors.required">* This field is required
                </div>
                <div *ngIf="getDemoForm.contactnumber.errors.pattern">* Please, Enter 10 digit
                  Mobile
                  Number.
                </div>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Company*</label>
              <input type="text" placeholder="Enter Your Company Name" id="form34" class="form-control validate input"
                formControlName="company_name" name="company_name"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.company_name.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.company_name.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.company_name.errors.required">* This field is required</div>
              </div>
            </div>

            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Designation*</label>
              <input type="text" placeholder="Enter Your Designation" id="form34" class="form-control validate input"
                formControlName="designation" name="designation"
                [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.designation.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.designation.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.designation.errors.required">* This field is required</div>
                <div *ngIf="getDemoForm.designation.errors.maxlength">* Please enter valid name</div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                Slot
                1*</label>
              <input type="datetime-local" id="form34" class="form-control validate input" formControlName="time_slot1"
                name="time_slot1" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot1.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.time_slot1.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.time_slot1.errors.required">* This field is required</div>
              </div>
            </div>
            <div class="md-form mb-20 col-md-6">
              <label class="mb-0" data-error="wrong" data-success="right" for="form34">Preferred Time
                Slot
                2*</label>
              <input type="datetime-local" id="form34" class="form-control validate input" formControlName="time_slot2"
                name="time_slot2" [ngClass]="{ 'is-invalid': demoSubmitted && getDemoForm.time_slot2.errors }">
              <div *ngIf="demoSubmitted && getDemoForm.time_slot2.errors" class="invalid-feedback">
                <div *ngIf="getDemoForm.time_slot2.errors.required">* This field is required</div>
              </div>
            </div>
          </div>
          <div class="md-form">
            <label class="mb-0" data-error="wrong" data-success="right" for="form8">How can we help
              you?</label>
            <textarea maxlength="250" placeholder="Must be under 250 characters." type="text" id="form8"
              class="md-textarea form-control" formControlName="message" name="message" rows="2">
            </textarea>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button class="btn btn-unique" id="closeModal" (click)="submitDemoForm()">Send</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal" aria-label="Close" (click)="onReset()">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>